// extracted by mini-css-extract-plugin
export default {"wrapper":"rC-z","button":"sC-z","alternate":"tC-z","disabled":"uC-z","paymentWarning":"vC-z","fadeIn":"wC-z"};